// extracted by mini-css-extract-plugin
module.exports = {"centered":"CenteredContainer_centered__wKfky"};